export const convertSavedRightsToPayload = (pageInfo) => {
  const savedRights = JSON.parse(localStorage.getItem("savedRights")) || [];

  const convertedRoles = savedRights.map((role) => {
    const rightsData = pageInfo.map((page) => {
      const parentPageRights = role.CheckedRights?.find((item) => item.page === page.parentPage);

      const parentRights = page?.parentRights.reduce((rightsAcc, right) => {
        if (right === "Level") {
          const levelValue = parentPageRights?.rights[right] || "none";
          rightsAcc[right.toLowerCase()] = levelValue;
        } else {
          rightsAcc[right.toLowerCase()] = parentPageRights && parentPageRights.rights[right] !== undefined ? parentPageRights.rights[right] : false;
        }
        return rightsAcc;
      }, {});

      const subRights = page?.childPages?.length
        ? page.childPages.map((childPage) => {
            const childPageRights = role.CheckedRights?.find((item) => item.page === childPage.childPageName && item.parent === page.parentPage);

            const subMenuRights = childPage?.childPageRights?.reduce((subRightsAcc, right) => {
              if (right === "Level") {
                const levelValue = childPageRights?.rights[right] || "none";
                subRightsAcc[right.toLowerCase()] = levelValue;
              } else {
                subRightsAcc[right.toLowerCase()] = childPageRights && childPageRights.rights[right] !== undefined ? childPageRights.rights[right] : false;
              }
              return subRightsAcc;
            }, {});

            return {
              subMenu: childPage?.childPageName,
              ...subMenuRights,
            };
          })
        : null;

      const isAllSelected = Object.entries(parentRights).every(([key, val]) => {
        if (key === "level") {
          return val !== "none";
        }
        return val === true;
      });

      return {
        menu: page.parentPage,
        ...parentRights,
        isAllSelected,
        subRights,
      };
    });

    return {
      roleName: role.RoleName,
      rights: rightsData,
    };
  });

  return convertedRoles;
};

const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const convertBackednResponseToLocalStorageFormat = (backendResponse, pageInfo) => {
  let convertedLocalStorageFormat = {
    RoleName: backendResponse.roleName,
    isAdmin: backendResponse.isAdmin,
    CheckedRights: backendResponse.rights.flatMap((menuItem) => {
      const matchingParent = pageInfo.find((page) => page.parentPage === menuItem.menu);
      if (!matchingParent) return [];

      const parentRights = Object.entries(menuItem).reduce((acc, [key, value]) => {
        const capitalizedKey = capitalizeFirstLetter(key);
        if (key !== "menu" && key !== "subRights" && key !== "isAllSelected") {
          if (key === "level") {
            acc[capitalizedKey] = value !== "none" ? value : "none";
          } else if (value === true) {
            acc[capitalizedKey] = true;
          }
        }
        return acc;
      }, {});

      const parentRightsEntry = Object.keys(parentRights).length > 0 ? { page: menuItem.menu, rights: parentRights, parent: menuItem.menu } : null;

      const subRightsEntries = menuItem?.subRights
        ?.map((subItem) => {
          const matchingChild = matchingParent.childPages?.find((child) => child.childPageName === subItem.subMenu);
          if (!matchingChild) return null;

          const subMenuRights = Object.entries(subItem).reduce((acc, [key, value]) => {
            const capitalizedKey = capitalizeFirstLetter(key);
            if (key !== "subMenu") {
              if (key === "level") {
                acc[capitalizedKey] = value !== "none" ? value : "none";
              } else if (value === true) {
                acc[capitalizedKey] = true;
              }
            }
            return acc;
          }, {});

          return Object.keys(subMenuRights).length > 0 ? { page: subItem.subMenu, rights: subMenuRights, parent: menuItem.menu } : null;
        })
        .filter((subItem) => subItem !== null);

      return [...(parentRightsEntry ? [parentRightsEntry] : []), ...(subRightsEntries ? subRightsEntries : [])];
    }),
  };

  return convertedLocalStorageFormat;
};
